const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/invitation_links/new/access.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/invitation_links/new/access")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});